/**
 * DialogOverlay — full-screen dim/blur backdrop for a modal, closing on
 * backdrop click. Generic (no dialog-specific content) so any feature's
 * modal can use it instead of re-implementing the same overlay markup.
 *
 * Extracted from the Data Profiler feature, which had its own private copy.
 */
export function DialogOverlay({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      {children}
    </div>
  );
}
